import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from '../../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {Order} from "../../../models/order";


@Component({
    selector: 'repeat-receipt-printing-dialog',
    templateUrl: './repeatReceiptPrintingDialog.component.html',
    styleUrls: ['./repeatReceiptPrintingDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class RepeatReceiptPrintingDialogComponent {
    action: string;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    isInvoice: boolean = false;
    order: Order;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<RepeatReceiptPrintingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.order = _data.order;
        this.translationLoader.loadTranslations(polish);
    }
}
